<script lang="ts">
    import { onDestroy } from 'svelte';
    import { getCometDContext } from './cometd.store';
    import { subscribeToJackpotsUpdates } from '$src/lib/services/gatekeeper/cometd/getCometdJackpotsMessagebusSubscriptions';

    import type { VoidFunction } from '$src/lib/common';

    const cometd = getCometDContext();
    let unsubscribeFromPublicChannel: VoidFunction | undefined;

    $: {
        // Unsubscribe before re-subscribing
        if (unsubscribeFromPublicChannel) {
            unsubscribeFromPublicChannel();
        }

        // Create a new subscription
        unsubscribeFromPublicChannel = subscribeToJackpotsUpdates($cometd);
    }

    onDestroy(() => {
        if (unsubscribeFromPublicChannel) {
            unsubscribeFromPublicChannel();
        }
    });
</script>
